<!--线路详情-->
<template>
  <div class="tw-xlxq">
    <div class="refresh">
      <van-icon name="replay" size="20" @click="handleRefreshClick"></van-icon>
    </div>
    <div class="tw-xlxq-head">
      <div class="tw-xlxq-head-title">线路详情</div>
      <van-icon
        name="arrow-left"
        size="17"
        color="#33639e"
        @click="handleBackClick"
        class="tw-xlxq-head-icon"
      />
      <div class="tw-xlxq-head-right" @click="handleLocaClick">
        <img src="../assets/image/gddt.png" width="100%" height="100%" alt="" />
        <span class="tw-xlxq-head-right-text">地图查看</span>
      </div>
    </div>
    <div class="tw-xlxq-body">
      <div class="tw-xlxq-body-head1">
        <div class="tw-xlxq-body-head1-name" v-if="busInfoList.line_alias">
          {{ busInfoList.line_alias }}
        </div>
        <div class="tw-xlxq-body-head1-cp" v-if="busInfoList.is_now == 'true'">
          <span v-if="busInfoList.runBusInfo.length != 0">{{
            busInfoList.runBusInfo[0].vehi_num
          }}</span>
        </div>
      </div>
      <div class="tw-xlxq-body-head">
        <div class="tw-xlxq-body-head-starend">
          {{ busInfoList.start_address }}站&nbsp;<i
            class="iconfont icon-right_2"
          ></i>
          {{ busInfoList.end_address }}站
        </div>
        <div class="tw-xlxq-body-head-begintime">
          发车时间:{{ busInfoList.start_time }}
        </div>
        <div class="tw-xlxq-body-head-endtime">
          预计到达时间:{{ busInfoList.arrive_time }}
        </div>

        <div class="tw-xlxq-body-head-right" @click="handleGonowClick">
          <img src="../assets/image/xzcf.png" alt="" width="80%" height="70%" />
          现在出发
        </div>
      </div>
      <div class="tw-xlxq-body-main">
        <div class="tw-xlxq-body-main-body">
          <div class="tw-xlxq-body-main-body-top">
            <div class="tw-xlxq-body-main-body-top-in">
              <div class="tw-xlxq-body-main-body-top-in-top">
                <template v-if="busInfoList.is_end == '0'">
                  <div
                    class="tw-xlxq-body-main-body-top-left"
                    v-if="
                      busInfoList.is_now == 'true' &&
                        busInfoList.runBusInfo.length != 0
                    "
                  >
                    <template
                      v-if="
                        busInfoList.runBusInfo[0].near_distance > 0 &&
                          runBusInfo[0].about_minute != 0
                      "
                    >
                      <div class="tw-xlxq-body-main-body-top-left-time">
                        约{{ runBusInfo[0].about_minute }}分
                      </div>
                      <div class="tw-xlxq-body-main-body-top-left-status">
                        <span v-if="busInfoList.runBusInfo[0].car_broken == 1"
                          >故障中</span
                        >
                        <span
                          v-else-if="busInfoList.runBusInfo[0].late_state == 0"
                          >晚点</span
                        >
                      </div>
                      <div class="tw-xlxq-body-main-body-top-left-text">
                        {{ runBusInfo[0].near_distance }}站/{{
                          formatterRice(runBusInfo[0].about_rice)
                        }}
                      </div>
                    </template>
                    <template
                      v-else-if="
                        runBusInfo[0].about_minute == 0 &&
                          runBusInfo[0].next_station ==
                            busStationList[busStationList.length - 1]
                              .station_alias_no
                      "
                    >
                      <div>
                        <div
                          class="tw-xlxq-body-main-body-top-left-text"
                          style="padding-top: 12%"
                        >
                          已到站
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div
                        class="tw-xlxq-body-main-body-top-left-text"
                        style="padding-top: 12%"
                      >
                        已过站
                      </div>
                    </template>
                  </div>
                  <div class="tw-xlxq-body-main-body-top-left" v-else>
                    <div
                      class="tw-xlxq-body-main-body-top-left-text"
                      style="padding-top: 12%"
                    >
                      暂未发车
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="tw-xlxq-body-main-body-top-left">
                    <div
                      class="tw-xlxq-body-main-body-top-left-text"
                      style="padding-top: 12%"
                    >
                      车辆已到达终点
                    </div>
                  </div>
                </template>
              </div>
              <div class="tw-xlxq-body-main-body-top-in-bottom">
                车辆距离本站的时间
              </div>
            </div>
          </div>
          <div
            class="tw-xlxq-body-main-body-mid"
            :class="{ noPc: formatterNopc }"
            ref="BusItem"
          >
            <div
              class="tw-xlxq-body-main-body-mid-item"
              ref="busIcon"
              v-for="(item, index) in busStationList"
              :key="index"
            >
              <div class="tw-xlxq-body-main-body-mid-item-icon">
                <!-- {{ nextStationList.indexOf(item.station_alias_no) }} -->
                <template v-if="busInfoList.is_end == '1'">
                  <img
                    v-if="
                      busStationList[busStationList.length - 1]
                        .station_alias_no == item.station_alias_no
                    "
                    class="item-icon-img1"
                    src="../assets/image/zhengchang1.png"
                    alt=""
                  />
                </template>
                <template v-else>
                  <div
                    v-if="
                      busInfoList.is_now == 'true' &&
                        nextStationList.indexOf(item.station_alias_no) > -1
                    "
                  >
                    <img
                      v-if="
                        busInfoList.runBusInfo[
                          nextStationList.indexOf(item.station_alias_no)
                        ].car_broken == 1
                      "
                      class="item-icon-img"
                      src="../assets/image/guzhang1.png"
                      alt=""
                    />
                    <img
                      v-else-if="
                        busInfoList.runBusInfo[
                          nextStationList.indexOf(item.station_alias_no)
                        ].near_distance < 1
                      "
                      class="item-icon-img"
                      src="../assets/image/guozhan1.png"
                      alt=""
                    />
                    <img
                      v-else-if="
                        busInfoList.runBusInfo[
                          nextStationList.indexOf(item.station_alias_no)
                        ].late_state == 0
                      "
                      class="item-icon-img"
                      src="../assets/image/wandian1.png"
                      width="80%"
                      height="80%"
                      alt=""
                    />
                    <img
                      v-else
                      class="item-icon-img"
                      src="../assets/image/zhengchang1.png"
                      alt=""
                    />
                  </div>
                </template>
              </div>
              <div class="tw-xlxq-body-main-body-mid-item-line"></div>
              <div
                class="tw-xlxq-body-main-body-mid-item-point1"
                v-if="$route.query.station == item.station_alias"
              >
                <img
                  src="../assets/image/xlt.png"
                  alt=""
                  width="65%"
                  height="65%"
                  style="padding-top:20%;padding-left:18%"
                />
              </div>
              <div class="tw-xlxq-body-main-body-mid-item-point" v-else></div>
              <div class="tw-xlxq-body-main-body-mid-item-arrow">
                <van-icon name="arrow" color="#fff" size="10" />
              </div>
              <div
                class="tw-xlxq-body-main-body-mid-item-text"
                :style="
                  $route.query.station == item.station_alias
                    ? 'color:#105efe'
                    : ''
                "
                @click="handleItemClick(item)"
              >
                <!-- {{ index + 1 }} -->
                {{ item.station_alias }}
              </div>
              <div class="lwzj" v-if="$route.query.near == item.station_alias">
                离我最近
              </div>
            </div>
          </div>
          <div class="remark" v-if="busInfoList.memo">
            备注:{{ busInfoList.memo }}
          </div>
        </div>
      </div>
    </div>
    <div class="tw-xlxq-bottom">
      <div class="tw-xlxq-bottom-text">小提示</div>
      <div class="tw-xlxq-bottom-bot">
        <div class="tw-xlxq-bottom-type">
          <img class="bottom-img" src="../assets/image/wandian.png" alt="" />
          <br />晚点
        </div>
        <div class="tw-xlxq-bottom-type">
          <img class="bottom-img" src="../assets/image/guzhang.png" alt="" />
          <br />
          故障
        </div>
        <div class="tw-xlxq-bottom-type">
          <img class="bottom-img" src="../assets/image/zhengchang.png" alt="" />
          <br />
          正常
        </div>
        <div class="tw-xlxq-bottom-type">
          <img class="bottom-img" src="../assets/image/guozhan.png" alt="" />
          <br />
          过站
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import $ from 'jquery'
import _ from 'underscore'
import moment from 'moment'
import { getBcStationList, getRunBus } from 'api/RouteDetailsAPI'
import { getBcByStationName } from 'api/indexAPI'

export default {
  name: 'RouteDetails',
  data() {
    return {
      busStationList: [],
      busInfoList: { runBusInfo: [{}] },
      list: null,
      nextStationList: [],
      busNowIndex: 0,
      runBusInfo: [],
      timer: null
    }
  },
  computed: {
    formatterNopc() {
      const version = window.navigator.appVersion
      return !(version.includes('Intel Mac OS') || version.includes('Windows'))
    }
  },
  mounted() {
    this.getBcStationList()
    this.$nextTick(() => {
      this.getBcByStationName()
      this.getBcByStationNameInter()
    })
  },
  methods: {
    //刷新
    handleRefreshClick() {
      location.reload()
    },
    handleBackClick() {
      // window.history.go(-1)
      this.$router.push({
        path: '/'
      })
    },
    //获取班车站点集合（一字排开页面）
    getBcStationList() {
      const params = new URLSearchParams()
      // params.append('bid','B002')
      params.append('bid', this.$route.query.bid)
      getBcStationList(params).then(res => {
        if (res.data.success == true) {
          this.busStationList = res.data.data
          var length = this.busStationList.length
          // var num = 100 / length
          // setTimeout(() => {
          //   console.info(this.$refs.BusItem.length)
          //   for (let i = 0; i < this.$refs.BusItem.length; i++) {
          //     this.$refs.BusItem[i].style.width = num + '%'
          //   }
          // })
        }
      })
    },
    //根据站点名称获取途经班车信息
    getBcByStationName() {
      this.nextStationList = []
      let _this = this
      const { bid, sno } = this.$route.query
      const params = new URLSearchParams()
      params.append('bid', bid)
      params.append('stationName', sno)
      getBcByStationName(params).then(res => {
        this.busInfoList = res.data.data[0]
        if (res.data.data[0] && res.data.data[0].runBusInfo == null) return
        this.runBusInfo = res.data.data[0].runBusInfo
        this.nextStationList = _.pluck(
          res.data.data[0].runBusInfo,
          'next_station'
        )
        _.each(this.busStationList, item => {
          if (this.nextStationList.indexOf(item.station_alias_no) > -1)
            this.busNowIndex = item.station_sort_no
        })
        setTimeout(() => {
          this.distanceJudge()
        })
      })
    },
    getBcByStationNameInter() {
      this.timer = setInterval(() => {
        this.nextStationList = []
        let _this = this
        const { bid, sno } = this.$route.query
        const params = new URLSearchParams()
        params.append('bid', bid)
        params.append('stationName', sno)
        getBcByStationName(params).then(res => {
          this.busInfoList = res.data.data[0]
          if (res.data.data[0] && res.data.data[0].runBusInfo == null) return
          this.runBusInfo = res.data.data[0].runBusInfo
          this.nextStationList = _.pluck(
            res.data.data[0].runBusInfo,
            'next_station'
          )
          _.each(this.busStationList, item => {
            if (this.nextStationList.indexOf(item.station_alias_no) > -1)
              this.busNowIndex = item.station_sort_no
          })
        })

        setTimeout(() => {
          this.distanceJudge()
        })
      }, 10000)
    },
    // 图标居中
    distanceJudge() {
      if (this.busNowIndex == 0) return
      this.$refs.BusItem.scrollLeft =
        this.$refs.busIcon[this.busNowIndex - 1].offsetLeft -
        document.body.clientWidth / 2
    },
    //地图查看
    handleLocaClick() {
      this.$router.push({
        path: '/zdxl/xlxq/xlt',
        query: {
          bid: this.$route.query.bid,
          near: this.$route.query.near,
          station: this.$route.query.station,
          sno: this.$route.query.sno
        }
      })
    },
    //现在出发点击事件
    handleGonowClick() {
      this.$router.push({
        path: '/cxjg',
        query: {
          start: this.busInfoList.start_address,
          end: this.busInfoList.end_address,
          time: moment(new Date()).format('YYYY-MM-DD HH:mm'),
          near: this.$route.query.near
        }
      })
    },
    //站点点击事件
    handleItemClick(item) {
      if (item.station_alias == this.$route.query.station) return
      this.$router.push({
        path: '/zdxl/xlxq',
        query: {
          bid: this.$route.query.bid,
          near: this.$route.query.near,
          station: item.station_alias,
          sno: item.station_alias_no
        }
      })
      this.getBcByStationName()
      this.getBcStationList()
    },
    // 格式化距离
    formatterRice(rice) {
      return rice.length <= 3 ? rice + 'm' : (rice / 1000).toFixed(1) + 'km'
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>

<style lang="scss" scoped>
.refresh {
  position: absolute;
  right: 10px;
  bottom: 60px;
  width: 20px;
  height: 20px;
  z-index: 10;
}
.remark {
  font-size: 15px;
  line-height: 20px;
  letter-spacing: 0.1em;
  padding: 3px;
  background-color: #fff;
  margin-top: 3px;
}
.tw-xlxq {
  position: relative;
  height: 100%;
  &-head {
    height: 50px;
    background-color: #fff;
    position: relative;
    border-bottom: 1px solid #ebeced;
    &-title {
      // text-align: center;
      font-size: 15px;
      font-weight: 700;
      letter-spacing: 2px;
      padding-top: 5%;
      padding-left: 10%;
      color: #33639e;
      box-sizing: border-box;
    }
    &-icon {
      position: absolute;
      left: 2%;
      top: 30%;
    }
    &-right {
      position: absolute;
      right: 28px;
      top: 12%;
      width: 25px;
      height: 25px;
      &-text {
        display: inline-block;
        width: 50px;
        margin-left: -10px;
        font-size: 10px;
        color: #9a9fa5;
        // color: #105efe;
      }
    }
  }
  &-body {
    height: calc(100% - 120px);
    overflow: auto;
    &-head1 {
      height: 30px;
      display: flex;
      &-name {
        // position: absolute;
        // top: 35%;
        // left: 7%;
        font-size: 17px;
        font-weight: 550;
        letter-spacing: 2px;
        padding-left: 20px;
        padding-right: 20px;
        color: #3377fe;
        height: 30px;
        line-height: 30px;
      }
      &-cp {
        // position: absolute;
        // top: 65%;
        // left: 7%;
        font-size: 15px;
        height: 40px;
        line-height: 40px;
        color: #a5a6a5;
      }
    }
    &-head {
      height: 80px;
      position: relative;
      background-color: #f6fafd;
      border-bottom: 1px solid #ebeced;
      &-name {
        position: absolute;
        top: 35%;
        left: 7%;
        font-size: 17px;
        font-weight: 550;
        letter-spacing: 2px;
        color: #3377fe;
      }
      &-cp {
        position: absolute;
        top: 65%;
        left: 7%;
        font-size: 15px;
        color: #a5a6a5;
      }
      &-function {
        position: absolute;
        letter-spacing: 0.5px;
        top: 35%;
        right: 5%;
        font-size: 14px;
        color: #f14f29;
      }
      &-starend {
        position: absolute;
        top: 15%;
        left: 6.5%;
        font-size: 16px;
        font-weight: 550;
      }
      &-begintime,
      &-endtime {
        position: absolute;
        font-size: 14px;
        bottom: 35%;
        color: #a5a6a5;
        left: 7%;
      }
      &-endtime {
        bottom: 5%;
      }
      &-right {
        position: absolute;
        font-size: 10px;
        right: 7%;
        top: 40%;
        height: 45px;
        width: 48px;
      }
    }
    &-main {
      height: calc(100% - 120px);
      // background-color: #dddddd;
      position: relative;
      &-body {
        background-color: #f6fafd;
        // padding: 5%;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        &-top {
          padding: 10px;
          box-sizing: border-box;
          background-color: #f6fafd;
          width: 100%;
          height: 130px;
          &-in {
            background-color: #ffffff;
            height: 100%;
            width: 100%;
            &-top {
              width: 100%;
              height: calc(100% - 30px);
              display: flex;
            }
            &-bottom {
              width: 100%;
              height: 30px;
              line-height: 30px;
              border-top: 1px solid #ebeced;
              text-align: center;
              color: #a9acbf;
            }
          }
          &-left {
            width: 100%;
            &-text {
              height: 35%;
              padding-top: 3%;
              font-size: 14px;
              text-align: center;
              box-sizing: border-box;
              font-weight: 550;
              color: #a9acbf;
            }
            &-time,
            &-status {
              height: 30%;
              text-align: center;
              font-size: 15px;
              color: #2070fc;
              padding-top: 5%;
              box-sizing: border-box;
            }
            &-status {
              color: #f4bc38;
              padding-top: 4%;
              box-sizing: border-box;
              font-size: 12px;
            }
          }
          &-mid {
            margin-top: 4%;
            height: 70%;
            width: 0px;
            border-left: 1px solid #e3e3e3;
          }
          &-right {
            width: 50%;
            &-next {
              height: 45%;
              padding-top: 15%;
              font-size: 16px;
              text-align: center;
              box-sizing: border-box;
            }
            &-time {
              height: 30%;
              text-align: center;
              font-size: 15px;
              color: #2070fc;
              padding-top: 5%;
              box-sizing: border-box;
            }
          }
        }
        &-mid {
          padding-top: 3%;
          overflow: auto;
          height: 63%;
          width: auto;
          overflow-y: hidden;
          overflow-x: scroll;
          white-space: nowrap;
          justify-content: space-between;
          background-color: #ffffff;
          // &::-webkit-scrollbar {
          //   display: none;
          // }
          &-item {
            display: inline-block;
            vertical-align: top;
            // float: left;
            width: 25%;
            height: 100%;
            position: relative;
            &:last-child {
              .tw-xlxq-body-main-body-mid-item-line {
                width: 80%;
              }
              .tw-xlxq-body-main-body-mid-item-arrow {
                display: none;
              }
            }
            &-icon {
              // width: 25px;
              height: 15%;
            }

            &-line {
              width: 110%;
              height: 10px;
              background-color: #3bacff;
              border-radius: 10px;
            }
            &-point {
              width: 7px;
              height: 7px;
              border-radius: 50%;
              background-color: #fff;
              position: absolute;
              top: 15.4%;
              left: 35%;
            }
            &-point1 {
              width: 30px;
              height: 30px;
              border-radius: 50%;
              background-color: #3bacff;
              position: absolute;
              top: 10%;
              left: 20%;
            }
            &-arrow {
              position: absolute;
              top: 14.8%;
              left: 80%;
            }
            &-text {
              width: 44px;
              padding-left: 25%;
              white-space: normal;
              line-height: 20px;
              text-align: center;
              padding-top: 10%;
              box-sizing: border-box;
            }
          }
        }
      }
    }
  }
  &-bottom {
    position: absolute;
    bottom: 0%;
    width: 100%;
    height: 70px;
    background-color: #fff;
    &-text {
      font-size: 10px;
      width: 100%;
      padding: 5px 0 0 10px;
      box-sizing: border-box;
    }
    &-bot {
      display: flex;
      height: calc(100% - 22px);
    }
    &-type {
      width: 25%;
      height: 100%;
      text-align: center;
    }
  }
}

.bottom-img {
  width: 25px;
  height: 15px;
  padding-top: 9%;
  padding-bottom: 9%;
  // box-sizing: border-box;
}

.item-icon-img {
  width: 25px;
  height: 15px;
  padding-top: 15%;
  margin-left: -10px;
}

.item-icon-img1 {
  width: 25px;
  height: 15px;
  padding-top: 15%;
  margin-left: 23px;
}
.lwzj {
  width: 24px;
  // padding-left: 5%;
  white-space: normal;
  line-height: 15px;
  font-size: 12px;
  text-align: center;
  padding-top: 5px;
  box-sizing: border-box;
  position: absolute;
  right: 20px;
  top: 20%;
  border: 1px solid #bfbfca;
  border-radius: 5px;
  color: #b6b6c2;
}
.noPc::-webkit-scrollbar {
  display: none;
}
</style>
